import * as React from "react";
import Switch from "react-router-dom/Switch";
import Redirect from "react-router-dom/Redirect";
import {SpreadPageLoader, BaseNotificationsStore} from "@vidazoo/ui-framework";
import {AppHeader, DefaultCharts} from "../../components";
import {NotificationStack} from "@vidazoo/ui/lib/components/notificationStack";
import * as theme from "./theme.scss";
import {appUrlsService} from "common/services";
import {currentUserStore, dashboardsStore} from "common/stores";
import UIStore from "common/stores/UIStore";
import {TimePresets} from "../../../../common/enums";
import {Route} from "react-router";

const Dashboard = React.lazy(() => import(/* webpackChunkName: "dashboard" */ "../../../dashboard/containers/dashboard/Dashboard"));
const Dashboards = React.lazy(() => import(/* webpackChunkName: "dashboards" */ "../../../dashboard/containers/dashboards/Dashboards"));
const Charts = React.lazy(() => import(/* webpackChunkName: "charts" */ "../../../chart/containers/charts/Charts"));
const Chart = React.lazy(() => import(/* webpackChunkName: "chart" */ "../../../chart/containers/chart/Chart"));
const ChangeLogs = React.lazy(() => import(/* webpackChunkName: "changeLogs" */ "../../../changeLogs/containers/ChangeLogs"));
const Reporting = React.lazy(() => import(/* webpackChunkName: "reporting" */ "../../../reporting/containers/reporting/Reporting"));
const ScheduleReports = React.lazy(() => import(/* webpackChunkName: "scheduleReports" */ "../../../scheduleReports/containers/list/ScheduleReportsList"));
const ScheduleReport = React.lazy(() => import(/* webpackChunkName: "scheduleReport" */ "../../../scheduleReports/containers/item/ScheduleReport"));
const NotificationCenter = React.lazy(() => import(/* webpackChunkName: "notificationCenter" */ "../../../../common/userNotifications/notificationCenter"));
const NotificationSettings = React.lazy(() => import(/* webpackChunkName: "notificationSettings" */ "../../../../common/userNotifications/notificationSettings"));

export interface IAppProps {
	userName?: string;
	userEmail?: string;
	userAvatarUrl?: string;
	onSignOut?: () => void;
	notificationsStore: BaseNotificationsStore;
	uiStore?: UIStore;
	userScopes?: string[];
	isVidazooNetwork?: () => boolean;
	setTimePreset: (name: string) => void;
	timePreset: TimePresets;
	userId?: string;
	cloudDashboardsStars: string[];
}

export interface IAppState {

}

export default class App extends React.Component<IAppProps, IAppState> {

	public static defaultProps: Partial<IAppProps> = {};

	constructor(props, context) {
		super(props, context);
	}

	public componentDidMount() {
		if (!dashboardsStore.charts || dashboardsStore.charts.length < 1) {
			dashboardsStore.getItems();
		}
	}

	public render(): JSX.Element {
		const {
			userScopes,
			userName,
			userEmail,
			userAvatarUrl,
			onSignOut,
			uiStore,
			notificationsStore,
			setTimePreset,
			timePreset,
			userId
		} = this.props;
		const lastChart = window.localStorage.getItem("lastChart")

		return (
			<div className={theme.app}>
				<AppHeader
					userName={userName}
					userEmail={userEmail}
					userAvatarUrl={userAvatarUrl}
					onSignOut={onSignOut}
					openMyProfile={uiStore.toggleProfileModal}
					userScopes={userScopes}
					userId={userId}
					cloudDashboardsStars={this.props.cloudDashboardsStars}
					dashboardsById={dashboardsStore.dashboardsById}
					setTimePreset={setTimePreset}
					timePreset={timePreset}
					apps={currentUserStore.apps}
					getApps={currentUserStore.getApps}
				/>

				{(!["/change-logs", "/schedule-reports"].includes(window.location.pathname) && !window.location.pathname.startsWith("/reporting") && !window.location.pathname.startsWith("/schedule-report") && dashboardsStore.defaultCharts.length > 0) ? (
					<DefaultCharts/>
				) : null}
				<NotificationStack
					verticalGap={6}
					horizontalGap={0}
					notifications={notificationsStore.notifications}
					onClose={notificationsStore.removeNotification}
				/>
				<div className={theme.pageContainer}>
					<React.Suspense fallback={<SpreadPageLoader blue/>}>
						<Switch>
							<Route path={appUrlsService.changeLogs()} component={ChangeLogs} />
							<Route path={appUrlsService.charts()} component={Charts} />
							<Route path={appUrlsService.chart()} component={Chart} />
							<Route path={appUrlsService.dashboards()} component={Dashboards} />
							<Route path={appUrlsService.dashboard()} component={Dashboard} />
							<Route path={appUrlsService.reporting()} component={Reporting} />
							<Route path={appUrlsService.scheduleReports()} component={ScheduleReports} />
							<Route path={appUrlsService.scheduleReport()} component={ScheduleReport} />
							<Route path={appUrlsService.notificationCenter()} component={NotificationCenter} />
							<Route path={appUrlsService.notificationSettings()} component={NotificationSettings} />
							<Redirect to={appUrlsService.viewChart(lastChart || "6329c84244c9a00e627fb270")}/>
						</Switch>
					</React.Suspense>
				</div>
			</div>
		);
	}
}
